import { getColumnToggleCookie } from '../../../../stores/algos-list-table-settings/reducers';
import { textAllCleaner } from '../../../text-cleaner';
import { searchTradingType } from './trading-type';
import { searchTransactionType } from './transaction-type';
import { searchUnderlyingSymbols } from './underlying-symbols';

const statuses = {
  TRADE_ACTIVE: 'Trade Active',
  TRADE_CLOSED: 'Trade Closed',
  READY: 'Ready',
};

export const filterSearchAlgos = (data, searchFilter) => {
  const search = textAllCleaner(searchFilter);
  const isSearchFilter = search !== '' ? true : false;

  if (!isSearchFilter) {
    return data;
  }

  const searchSplitRaw = search.split(',');
  const searchArray = searchSplitRaw
    .filter((search) => search && search?.trim() !== '')
    .map((search) => search?.trim()?.toLowerCase());

  if (!searchArray.length) {
    return data;
  }

  const toggleFields = getColumnToggleCookie();

  const searchData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    const searchMatchMap = searchArray.map((item) =>
      Object.assign({
        searchTerm: item,
        matched: false,
      })
    );

    const name = textAllCleaner(element.name);

    const status = element?.status || '';

    let statusPick = statuses[status] ? statuses[status] : status;

    if (statusPick === 'NOT_RUNNING') {
      statusPick = element?.enabled ? 'enabled' : 'disabled';
    }

    statusPick = statusPick?.toLowerCase();

    const brokerClientId = element?.broker?.startsWith('forward-testing-')
      ? textAllCleaner('')
      : textAllCleaner(element?.brokerClientId);
    const brokerDisplayName = textAllCleaner(element?.brokerDisplayName);
    const signalType = element?.type || '';

    for (
      let indexSearchArray = 0;
      indexSearchArray < searchArray.length;
      indexSearchArray++
    ) {
      const searchTerm = searchArray[indexSearchArray];

      if (name.includes(searchTerm)) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (statusPick.includes(searchTerm)) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (brokerClientId.includes(searchTerm)) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (brokerDisplayName.includes(searchTerm)) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (
        toggleFields?.startTime !== false &&
        element?.startTime?.includes(searchTerm)
      ) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (
        toggleFields?.endTime !== false &&
        element?.endTime?.includes(searchTerm)
      ) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (
        toggleFields?.tradingType !== false &&
        element?.tradingType &&
        searchTradingType(element?.tradingType, searchTerm)
      ) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (
        element?.transactionTypes?.length &&
        toggleFields?.transactionType !== false &&
        searchTransactionType(element?.transactionTypes, searchTerm)
      ) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (
        searchTerm.includes('underlying:') &&
        element?.underlyings?.length &&
        searchUnderlyingSymbols(element?.underlyings, searchTerm)
      ) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (element?._id === searchTerm && toggleFields?._id !== false) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }

      if (signalType === 'SIGNAL' && searchTerm.includes('signal')) {
        if (!searchMatchMap[indexSearchArray].matched) {
          searchMatchMap[indexSearchArray].matched = true;
        }

        if (searchMatchMap.every((item) => item.matched)) {
          searchData.push(element);
          continue;
        }
      }
    }
  }

  return searchData;
};
